import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationLicensePatch = {
    path: "/license",
    method: ERouteHttpVerb.PATCH
};
export { routeLocationLicensePatch };
